$('.expand-all').on('click', function() {
  $(this).toggleClass('opened')
  const $this = $(this);
  const $grid = $this.closest('.accordion-grid-wrapper');
  const $accordions = $grid.find('.faqs_details');

  if ($this.children().text() === 'Expand All') {
    $accordions.each(function() {
      $(this).attr('open', true);
    });
    $this.children().text('Close All');
  } else {
    $accordions.each(function() {
      $(this).removeAttr('open');
    });
    $this.children().text('Expand All');
  }
});
